import { render, staticRenderFns } from "./createParceiros.vue?vue&type=template&id=39b2041c&scoped=true&"
import script from "./createParceiros.vue?vue&type=script&lang=js&"
export * from "./createParceiros.vue?vue&type=script&lang=js&"
import style0 from "./createParceiros.vue?vue&type=style&index=0&id=39b2041c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b2041c",
  null
  
)

export default component.exports